import React from "react";
import { Col, Container, Row } from "react-bootstrap";
// import ContentFrom from "../components/webform";
import { StaticImage } from "gatsby-plugin-image";
import Businessautofooterform from "../components/businessautofooterform";

function Gettouch(props) {
  return (
    <div className="gettouch  p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Request Your <span>Free Demo</span>
              </h2>
            </div>
            <p style={{ color: "#898989" }}>
              Experience firsthand how TekRevol's Business Process Automation
              solutions can revolutionize your operations. Fill out the form
              below to schedule your personalized demo
            </p>
            <div className="get-img mt-4 mt-md-5">
              <StaticImage
                src="../../images/business-automation/request-demo-img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={686}
                height={504}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <Businessautofooterform />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
